module.exports = __webpack_public_path__ + "img/7.6f4bcf4b.jpg";